var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgController = function SvgController(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 74,
    viewBox: "0 0 60 74",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9FADC5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.891,
    cy: 40.951,
    r: 3.563,
    transform: "rotate(-45 15.891 40.951)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.09 23.835H40.828v-1.23a2.042 2.042 0 00-2.042-2.042h-6.77V8.971a4.79 4.79 0 10-4.675 0v11.592h-6.78a2.045 2.045 0 00-2.042 2.042v1.23H3.254A3.266 3.266 0 000 27.1v43.361a3.266 3.266 0 003.266 3.266H56.09a3.266 3.266 0 003.266-3.266V27.101a3.266 3.266 0 00-3.266-3.266zM16.593 66.17c0 .625-.507 1.132-1.132 1.132H7.324a1.132 1.132 0 01-1.132-1.132v-2.414a1.132 1.132 0 011.132-1.129h8.136c.624 0 1.13.505 1.132 1.13v2.413zm-.7-16.203a9.014 9.014 0 110-18.029 9.014 9.014 0 010 18.029zm18.559-9.014a9.014 9.014 0 1118.028 0 9.014 9.014 0 01-18.028 0zM53.17 66.17c0 .625-.507 1.132-1.132 1.132h-8.145a1.132 1.132 0 01-1.129-1.132v-2.414a1.132 1.132 0 011.13-1.129h8.138c.624 0 1.13.505 1.132 1.13l.006 2.413z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.03 40.954a3.565 3.565 0 10-7.13-.006 3.565 3.565 0 007.13.006z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgController, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/controller.980f269e.svg";
export { ForwardRef as ReactComponent };